import React from 'react';
import {StyleSheet} from 'react-native';
import {Swiper} from '../swiper';
import {Props} from './model';
import {SwiperSlide} from 'swiper/react';
import {NewsCard} from '../newsCard';
import {LoadableContent} from '../loadableContent';
import {DeviceSize} from '../../theme/helpers';

const styles = StyleSheet.create({
  card: {
    marginHorizontal: 15,
    height: '100%',
  },
  loadableContent: {
    justifyContent: 'center',
  },
  newsContainer: {
    flexBasis: '100%',
    flexGrow: 1,
  },
});

const breakpoints = {
  [DeviceSize.tablet]: {
    slidesPerView: 2,
  },
  [DeviceSize.desktop]: {
    slidesPerView: 3,
  },
  1300: {
    slidesPerView: 4,
  },
};

export default ({news}: Props) => {
  return (
    <LoadableContent testID='desktop-news-carousel-container-id' style={styles.loadableContent} loading={!news}>
      <Swiper testID='news-carousel-swiper-id' breakpoints={breakpoints}>
        {news?.map((newsItem) => (
          <SwiperSlide key={newsItem.id}>
            <NewsCard news={newsItem} style={styles.card} containerStyles={styles.newsContainer} />
          </SwiperSlide>
        ))}
      </Swiper>
    </LoadableContent>
  );
};
